import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@guildeducationinc/recess';
import { ProgramStatus } from '@src/types';
import classNames from 'classnames';
import { useLocale } from 'pe-core-frontend';
import styles from './ProgramStatusTag.module.scss';
const getColors = (status) => {
    let outline = 'background-color-1';
    const text = 'text-color-1';
    let bg = 'background-color-1-tint-1';
    switch (status) {
        case ProgramStatus.INFO_REQUESTED:
            outline = 'background-color-3';
            bg = 'background-color-3-lighten-50';
            break;
        case ProgramStatus.ACTIVE:
            outline = 'background-color-4';
            bg = 'background-color-4-lighten-50';
            break;
        case ProgramStatus.REJECTED:
        case ProgramStatus.CANCELLED:
            outline = 'background-color-2';
            bg = 'background-color-2-lighten-50';
            break;
    }
    return {
        outline,
        text,
        bg,
    };
};
export const ProgramStatusTag = ({ status, size = 'small' }) => {
    const { t } = useLocale();
    const { outline, text, bg } = getColors(status);
    return (_jsx("div", { children: _jsx("div", { className: classNames(styles.tag, size === 'large' && styles.large), style: {
                color: `var(--${text})`,
                backgroundColor: `var(--${bg})`,
                borderColor: `var(--${outline})`,
            }, children: _jsx(Typography, { variant: size === 'large' ? 'body1' : 'label2', weight: '400', className: styles.status, children: t(`programStatus.${status}`) }) }) }));
};
